/*
  Comparsa delle sezioni — ogni sezione della pagina, quando entra nello
  schermo, sale di poco e compare in dissolvenza. Lo stile sta in
  assets/parma.css (.p-comparsa).

  Si nascondono solo le sezioni sotto lo schermo all'apertura: quelle gia'
  visibili restano come sono, cosi' niente lampeggia. Niente effetto
  nell'editor del tema e con "riduci movimento".
*/
(function () {
  if (window.parmaComparsa) return;
  window.parmaComparsa = true;

  if (!('IntersectionObserver' in window)) return;
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function avvia() {
    var osservatore = new IntersectionObserver(
      function (voci) {
        voci.forEach(function (voce) {
          if (!voce.isIntersecting) return;
          voce.target.classList.add('p-comparsa--vista');
          osservatore.unobserve(voce.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px' }
    );

    document.querySelectorAll('#MainContent > .shopify-section').forEach(function (sezione) {
      if (sezione.getBoundingClientRect().top < window.innerHeight) return;
      sezione.classList.add('p-comparsa');
      osservatore.observe(sezione);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia);
  else avvia();
})();
